import { request } from "../request";
export const getXhsSign = (params) =>
  request(`/v1/xiaohongshu/sign`, "get", { params });
